module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAKRJREFUOI3VU1sOg0AInD4O0qNwM9Kb2JPUnkx/hogIrGn600k24AjDYxX4ES4FL7RKO9N+nL/DLeEUwATgwaQXfZA3wRZvHmliFMDSxShFIrKEKhZoqlR82rliW+xZIfFdXav2vkVXtVvsEolsXhOpRrb3O8RbGIlYzkEoqstABCycxtjHeBZtodE4JeL1209sgsJnwbZHQYJ7wj2d70ed3fkDrAq5LgZB7tWfAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/TjianliTime.png
// module id = XF29
// module chunks = 1